import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import ColorPicker from '../../../reusable/ColorPicker/ColorPicker';
import FormTextField from '../../../components/DynamicForm/FormTextField';

import styles from './Details.module.scss';

interface SettingSectionProps {
	inspectorTheme?: boolean;
	formTemplate: any;
	onChange: (_value: any) => void;
}

const SettingSection = ({ inspectorTheme = false, formTemplate, onChange }: SettingSectionProps) => {
	const { t } = useTranslation();
	const [settings, setSettings] = useState<any>(formTemplate?.settings ?? {});

	const handleSettingChange = (key: string, value: any) => {
		const updatedSettings = { ...settings, [key]: value };
		setSettings(updatedSettings);
		onChange({ ...formTemplate, settings: updatedSettings });
	};

	useEffect(() => {
		setSettings(formTemplate?.settings ?? {});
	}, [formTemplate]);

	return (
		<div className={`${styles.sectionContainer} ${inspectorTheme ? styles.sectionContainerInpsectorTheme : ''}`}>
			<div className={styles.sectionTop}>
				<strong>{t('COMMON_SETTINGS')}</strong>
			</div>
			<div className={styles.sectionContent}>
				{/* <div className={styles.formTitle}>
					<label>{t('INSPECT_MEDIA_MINI_FORM_SETTING_TEXT_COLOR')}</label>
					<div style={{ marginTop: '8px' }}>
						<ColorPicker
							width="36px"
							height="20px"
							borderRadius="4px"
							padding="2px"
							color={settings.textColor ?? '#000000'}
							disableAlpha
							onChangeComplete={({ hex }: { hex: string }) => handleSettingChange('textColor', hex)}
						/>
					</div>
				</div> */}
				<div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}>
					<div className={styles.formTitle}>
						<label>{t('INSPECT_MEDIA_MINI_FORM_SETTING_BUTTON_COLOR')}</label>
						<div style={{ marginTop: '8px' }}>
							<ColorPicker
								width="36px"
								height="20px"
								borderRadius="4px"
								padding="2px"
								color={settings.buttonColor ?? '#126CFC'}
								disableAlpha
								onChangeComplete={({ hex }: { hex: string }) => handleSettingChange('buttonColor', hex)}
							/>
						</div>
					</div>
					<div className={styles.formTitle}>
						<label>{t('INSPECT_MEDIA_MINI_FORM_SETTING_BUTTON_TEXT_COLOR')}</label>
						<div style={{ marginTop: '8px' }}>
							<ColorPicker
								width="36px"
								height="20px"
								borderRadius="4px"
								padding="2px"
								color={settings.buttonTextColor ?? '#FFFFFF'}
								disableAlpha
								onChangeComplete={({ hex }: { hex: string }) => handleSettingChange('buttonTextColor', hex)}
							/>
						</div>
					</div>
				</div>
				<div className={styles.formTitle}>
					<FormTextField
						id="logo-url"
						title={t('INSPECT_MEDIA_MINI_FORM_SETTING_LOGO_URL')}
						label={true}
						value={settings.logoUrl ?? ''}
						onChange={(_, val) => handleSettingChange('logoUrl', val)}
					/>
				</div>
				<div className={styles.formTitle}>
					<FormTextField
						id="privacy-policy-url"
						title={t('INSPECT_MEDIA_MINI_FORM_SETTING_PRIVACY_POLICY_URL')}
						label={true}
						value={settings.privacyPolicyLink ?? ''}
						onChange={(_, val) => handleSettingChange('privacyPolicyLink', val)}
					/>
				</div>
			</div>
		</div>
	);
};

export default SettingSection;
